import { render } from "./AcademicWeekendSecondary.vue?vue&type=template&id=756ee80e&scoped=true"
import script from "./AcademicWeekendSecondary.vue?vue&type=script&lang=js"
export * from "./AcademicWeekendSecondary.vue?vue&type=script&lang=js"

import "./AcademicWeekendSecondary.vue?vue&type=style&index=0&id=756ee80e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-756ee80e"]])

export default __exports__